<template>
  <div class="managerOrder">
    <div class="panel-header">
      <h3 class="panel-header__title">计划管理</h3>
      <span class="panel-header__subtitle">PLAN MANAGEMENT</span>
      <a class="panel-header__export" v-if="dataUrls" :href="dataUrls">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        计划管理
        <el-button type="primary" class="fr" @click="add_order">
          <b>+&nbsp;</b>
          <i>新增计划</i>
        </el-button>
      </h3>
      <div class="panel-content__select-list">
        <ny-select
          :data="order.list"
          v-model="order.value"
          @change="changeSelect"
          :keyValue="['value', 'name']"
          type="order"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <el-input v-if="isAdPut" icon="search" class="mr5" v-model="filterValue"></el-input>
        <ny-select
          v-if="isStatusShow"
          :data="put.list"
          v-model="put.value"
          @change="changeSelect"
          :keyValue="['value', 'name']"
          type="put"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <ny-select
          :data="orderManage.flowTypeMenu"
          v-model="mediaSelect.flowType"
          @change="changeMediaSelect"
          type="flowType"
          :keyValue="['value', 'name']"
          placeholder="请选择"
          class="mb20 mr5 input_sm"
          v-if="isFlowTypeShow"
        ></ny-select>
        <ny-select
          :data="orderManage.portTypeMenu"
          v-model="mediaSelect.portType"
          @change="changeMediaSelect"
          type="portType"
          v-if="isPortTypeShow"
          :keyValue="['value', 'name']"
          placeholder="请选择"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <ny-select
          :data="orderManage.mediaMenu"
          v-model="mediaSelect.media"
          @change="changeMediaSelect"
          type="media"
          :keyValue="['value', 'name']"
          placeholder="请选择"
          v-if="isMediaShow"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <ny-select
          :data="orderManage.placeAttrMenu"
          v-model="mediaSelect.placeAttr"
          @change="changeMediaSelect"
          :keyValue="['value', 'name']"
          type="placeAttr"
          placeholder="请选择"
          v-if="isPlaceAttrShow"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <ny-select
          :data="orderManage.channelTypeMenu"
          v-model="mediaSelect.channelType"
          :keyValue="['value', 'name']"
          @change="changeMediaSelect"
          type="channelType"
          placeholder="请选择"
          v-if="isChannelTypeShow"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <ny-select
          :data="orderManage.channelMenu"
          v-model="mediaSelect.channel"
          :keyValue="['value', 'name']"
          @change="changeMediaSelect"
          type="channel"
          placeholder="请选择"
          v-if="isChannelShow"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <ny-select
          :data="orderManage.positionMenu"
          v-model="mediaSelect.position"
          :keyValue="['value', 'name']"
          @change="changeMediaSelect"
          type="position"
          placeholder="请选择"
          v-if="isPositionShow"
          class="mb20 mr5 input_sm"
        ></ny-select>
        <el-button class="mb20" @click="searchData">搜索</el-button>
        <div class="fr mr20" v-if="user.id_tag !== 9">
          <el-button @click="batchStartAndStopAd('batchStart', ids)">批量开始</el-button>
          <el-button class="is-warning" @click="batchStartAndStopAd('batchStop', ids)">批量暂停</el-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table
          class="tableBox mt20"
          row-key="id"
          :page="page"
          selection
          pagination
          @up:selection-change="handleSelectChange"
          :fixedColumns="{}"
          :width-columns="{id: 80, order_name: 260, time_str: 180, status_msg: 100, updated_at: 150 }"
          :slot-contents="['order_name', 'status_msg']"
          @up:current-change="currentChange"
          @up:size-change="sizeChange"
        >
          <template slot="order_name:content" slot-scope="{ row }">
            <span @click="handleAdverClick(row)"  class="panel-content__table-link">{{row.order_name }}</span>
          </template>
          <template slot="status_msg:content" slot-scope="{ row }">
            <div class="panel-content__table-status-box">
              <span
                class="panel-content__table-status"
                :class="{'is-active' : row.status_msg === '已启用'}"
              ></span>
              <span>{{ row.status_msg }}</span>
            </div>
          </template>
          <template slot="up:operate">
            <el-table-column label="开启" align="center" fixed="right" width="60">
              <template slot-scope="scope">
                <template v-if="scope.row.status !== 2">
                  <up-switch
                    :value="scope.row.status === 1"
                    @change="timeOut(scope.row, stopStatuses)"
                  ></up-switch>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240" fixed="right" align="center">
              <template slot-scope="scope">
              <div>
                <el-button
                    v-if="scope.row.is_delete === 0 && scope.row.status !== 2 && scope.row.status !== 1"
                    @click="edit(scope.row)"
                    size="small"
                    class="is-edit"
                  >编辑</el-button>
                <el-button size="small" class="is-view" @click="readInfo(scope.row)">查看</el-button>
                <el-button
                  v-if="(scope.row.status !== 2 && orderManage.mediaType === 'radio') || scope.row.is_delete === 0"
                  @click="stop(scope.row, scope.row.id)"
                  size="small"
                  class="is-remove"
                >停止</el-button>
                <el-button size="small" @click="coypInfo(scope.row)">复制</el-button>
              </div>
              </template>
            </el-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs'
import { mapActions, mapGetters } from 'vuex';
import { tip } from '@/global/util/util';
import { NySelect } from '@/global/components';
export default {
  components: {
    NySelect
  },
  data() {
    this.stopStatuses = ['排期已过']
    return {
      data: {},
      isAdPut: true,
      isStatusShow: false,
      orderSelectList: [],
      isFlowTypeShow: false,
      isPortTypeShow: false,
      isMediaShow: false,
      isPlaceAttrShow: false,
      isPositionShow: false,
      isChannelTypeShow: false,
      isChannelShow: false,
      order: {
        list: [],
        value: ''
      },
      put: {
        list: [],
        value: ''
      },
      ids: [],
      mediaSelect: {
        flowType: '',
        portType: '',
        media: '',
        placeAttr: '',
        channelType: '',
        channel: '',
        position: ''
      },
      page: {
        headers: {},
        data: [],
        pageSize: 10,
        currentPage: 1,
        total: 0,
        loading: false
      },
      dataUrls: '',
      search_key: '',
      filterValue: '',
      status: [],
      curStatus: 0,
      selectRows: [],
      groupOpr: false
    };
  },
  async created() {
    this.platform = this.$router.currentRoute.meta.platform // 定义标识当前系统的常量
    await Promise.all([this.getItem(), this.getStatus()])

    const { name, value } = this.$route.query
    this.order.value = value
    this.filterValue = name
    this.getListOrder()
  },
  computed: {
    ...mapGetters({
      orderManage: 'orderManage',
      userid: 'login/userid',
      user: 'login/user'
    })
  },
  methods: {
    ...mapActions(['orderItem', 'orderList', 'addOrder', 'stopOrder', 'switchOrder', 'batchStart', 'batchStop']),
    getItem() { // 获取第一个筛选列表
      this['orderItem']({ data: 'select_order_admin', platform: this.platform }).then(data => {
        if (data && data.code === 1) {
          this.order.list = data.data
          if (this.orderManage.mediaType !== 'radio') {
            this.order.list = this.order.list.filter(item => {
              return item.name !== '媒体'
            })
          }
          this.order.value = data.data[0].value
        }
      })
    },
    getStatus() { // 获取计划状态列表
      this['orderItem']({ data: 'status', platform: this.platform }).then(data => {
        if (data && data.code === 1) {
          this.put.list = data.data
          this.put.value = data.data[0].value
        }
      })
    },
    getFlowType() {
      this.$store.dispatch('getCommonPlace', {
        params: 'flow_type',
        data: {
          platform: this.platform
        },
        api: 'ORDER_FLOW_TYPE_MENU',
        isAll: true
      })
      this.mediaSelect.flowType = this.orderManage.curFlowType
    },
    getPortTypeMenu({ flowType, def } = {}) {
      this.$store.dispatch('getCommonPlace', {
        params: 'port_type',
        data: {
          platform: this.platform,
          flow_type: flowType || this.mediaSelect.flowType
        },
        api: 'ORDER_PORT_TYPE_MENU',
        isAll: true
      })
      this.mediaSelect.portType = this.orderManage.curPortType
    },
    getMediaMenu({ flowType, portType, def } = {}) {
      this.$store.dispatch('getCommonPlace', {
        params: 'media',
        data: {
          platform: this.platform,
          port_type: portType || this.mediaSelect.portType,
          flow_type: flowType || this.mediaSelect.flowType,
          advertiser_id: this.mediaSelect.advertiser
        },
        api: 'ORDER_MEDIA_MENU',
        isAll: true
      })
      this.mediaSelect.media = this.orderManage.curMedia
    },
    getPlaceAttrMenu({ flowType, portType, media } = {}) {
      this.$store.dispatch('getCommonPlace', {
        params: 'place_attribute',
        data: {
          platform: this.platform,
          port_type: portType || this.mediaSelect.portType,
          media: media || this.mediaSelect.media,
          flow_type: flowType || this.mediaSelect.flowType,
          advertiser_id: this.mediaSelect.advertiser
        },
        api: 'ORDER_PLACE_ATTRIBUTE_MENU',
        isAll: true
      })
      this.mediaSelect.placeAttr = this.orderManage.curPlaceAttr
    },
    async getChannelTypeMenu() {
      await this.$store.dispatch('getCommonPlace', {
        params: 'channel_type',
        data: {
          platform: this.platform
        },
        api: 'ORDER_CHANNEL_TYPE_MENU'
      })
      this.mediaSelect.channelType = this.orderManage.curChannelType
    },
    async getChannelMenu(api) {
      await this.$store.dispatch('getCommonPlace', {
        params: 'channel',
        data: {
          channel_type: api || this.order.channelType,
          platform: this.platform
        },
        api: 'ORDER_CHANNEL_MENU'
      })
      this.mediaSelect.channel = this.orderManage.curChannel
      this.getPositionMenu()
    },
    getPositionMenu() {
      let arr = [this.mediaSelect.flowType, this.mediaSelect.portType, this.mediaSelect.media, this.mediaSelect.placeAttr]
      let isEmpty = true
      arr.forEach(res => {
        if (res === '') {
          isEmpty = false
          return false
        }
      })
      if (isEmpty) {
        let params = {
          flow_type: this.mediaSelect.flowType,
          port_type: this.mediaSelect.portType,
          media_channel_id: this.mediaSelect.media,
          place_attribute: this.mediaSelect.placeAttr
        }
        if (this.mediaSelect.media === '1' && this.mediaSelect.placeAttr === '2' && this.mediaSelect.flowType === '1') {
          params.channel_type = this.mediaSelect.channelType
          if (this.mediaSelect.channelType !== '3') {
            params.channel = this.mediaSelect.channel
          }
        }
        this.$store.dispatch('getPosition', { params, isAll: true })
        this.mediaSelect.position = this.orderManage.curPosition
      } else {
        return false
      }
    },
    changeMediaSelect({ type, value }) {
      if (type === 'flowType' && value !== '') {
        this.getPortTypeMenu()
      } else if (type === 'portType' && value !== '') {
        this.getMediaMenu()
      } else if (type === 'media' && value !== '') {
        this.getPlaceAttrMenu()
      } else if (type === 'placeAttr' && value !== '') {
        if (value === '2') {
          this.getChannelTypeMenu()
          this.getChannelMenu(this.orderManage.curChannelType)
        } else {
          this.getPositionMenu()
        }
      } else if (type === 'channel' || type === 'channelType') {
        if (type === 'channelType') {
          this.getChannelMenu(this.mediaSelect.channelType)
        } else {
          this.getPositionMenu()
        }
      }
      this.isMediaSelectShow()
    },
    isMediaSelectShow() {
      this.isPortTypeShow = this.isFlowTypeShow && this.mediaSelect.flowType !== ''
      this.isMediaShow = this.isPortTypeShow && this.mediaSelect.portType !== ''
      this.isPlaceAttrShow = this.isMediaShow && this.mediaSelect.media !== ''
      this.isPositionShow = this.isPlaceAttrShow && this.mediaSelect.placeAttr !== ''
      this.isChannelTypeShow = (this.mediaSelect.media === '1' && this.mediaSelect.placeAttr === '2' && this.mediaSelect.flowType === '1' && this.isPositionShow)
      this.isChannelShow = this.isChannelTypeShow && this.mediaSelect.channelType !== '3'
    },
    getListOrder() {
      this.page.loading = true;
      let params = {
        order_name: this.order.value === 'order_name' ? this.filterValue : '',
        advertiser_name: this.order.value === 'advertiser_name' ? this.filterValue : '',
        status: this.order.value === 'status' ? this.put.value : '',
        account_name: this.order.value === 'account_name' ? this.filterValue : '',
        flow_type: this.isFlowTypeShow ? this.mediaSelect.flowType : '',
        port_type: this.isPortTypeShow ? this.mediaSelect.portType : '',
        media: this.isMediaShow ? this.mediaSelect.media : (this.orderManage.mediaType === 'global' ? '-1' : ''),
        place_attribute: this.isPlaceAttrShow ? this.mediaSelect.placeAttr : '',
        channel_type: this.isChannelTypeShow ? this.mediaSelect.channelType : '',
        channel: this.isChannelShow ? this.mediaSelect.channel : '',
        place_id: this.isPositionShow ? this.mediaSelect.position : '',
        page: this.page.currentPage,
        count: this.page.pageSize,
        id: this.order.value === 'id' ? this.filterValue : ''
      }
      let api = this.orderManage.mediaType !== 'radio' ? 'global-order' : 'order'
      this.$store.dispatch('orderList', { data: params }).then((data) => {
        this.page.loading = false;
        if (data && data.code === 1) {
          params.count = 5000
          this.dataUrls = `${BASE_URL}/${this.platform}/${api}/export?${qs.stringify(params)}`
          this.page.header = data.header
          this.page.data = data.data.data
          this.page.total = data.data.total
        }
      });
    },
    changeSelect({ type, value }) {
      if (type === 'order') {
        if (value === 'medias') {
          this.getFlowType()
        }
        this.isAdPut = (value !== 'status' && value !== 'medias')
        this.isStatusShow = value === 'status'
        this.isFlowTypeShow = value === 'medias'
      }
      this.isMediaSelectShow()
      this[type].value = value;
    },
    handleClick() {
      if (this.orderManage.mediaType === 'radio') {
        this.getItem()
      } else {
        this.order.list = this.order.list.filter(item => {
          return item.name !== '媒体'
        })
      }
      this.getItem()
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.page.data = []
      this.getListOrder();
    },
    searchData() {
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getListOrder();
    },
    async timeOut(row, stopStatuses) {
      // if (row.status === 1) {
      //   this.curStatus = 1;
      // } else if (row.status === 0) {
      //   this.curStatus = 0;
      // }
      if (row.status !== 2 && stopStatuses.includes(row.status_msg)) {
        return tip(`计划状态为“${row.status_msg}”的计划无法开启！`);
      }
      const type = row.status === 0 ? 'batchStart' : 'batchStop'
      await this[type]({
        data: {
          ids: [row.id]
        }
      }).then((data) => {
        if (data && data.code === 1) {
          this.getListOrder();
        } else {
          this.$message(data.msg)
        }
      })
      /* this.$store.dispatch('switchOrder', { data: { id: row.id } }).then((data) => {
        if (data && data.code === 1) {
          this.getListOrder();
        } else {
          this.$message(data.msg)
        }
      }); */
    },
    async batchStartAndStopAd(type, ids) {
      if (ids.length < 1) { return tip('请至少选择一个计划进行批量操作') }
      this[type]({ data: { ids: ids } }).then(res => {
        if (res.code === 1) {
          this.$message({
            type: 'success',
            message: '批量操作成功'
          })
          this.getListOrder()
        } else {
          return tip('批量操作失败')
        }
      })
    },
    handleSelectChange({ selection }) {
      this.ids = selection.map(v => v.id)
    },
    sizeChange(page) { // 当表格显示条数发生变化是触发的函数
      this.page.pageSize = page.pageSize;
      this.getListOrder();
    },
    currentChange(page) { // 当页面发生变化时触发的函数
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getListOrder();
    },
    add_order() {
      this.$router.push({ name: 'orderAdd', params: { media: this.orderManage.mediaType } })
    },
    stop(row, id) {
      this.$confirm('“确认永久停止此计划？”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('stopOrder', { data: { id: id }, mediaType: this.orderManage.mediaType }).then((data) => {
          if (data && data.code === 1) {
            this.$message({
              type: 'success',
              message: '已停止!'
            });
            this.getListOrder();
          }
        });
      });
    },
    handleCellClick({ row, column, cell }) {
      if (['order_name'].indexOf(column.property) > -1) {
        // this.order.value = column.property
        // this.filterValue = row[column.property]
        // this.searchData()
        this.$router.push({ path: '/advertiseList', query: { name: row[column.property], value: 'order_name' } })
      }
    },
    handleAdverClick(row) {
      this.$router.push({ path: '/advertiseList', query: { name: row.order_name, value: 'order_name' } })
    },
    readInfo(row) {
      this.$router.push({ name: 'orderOpr', params: { id: row.id, type: 'show', media: this.orderManage.mediaType } });
    },
    edit(row) {
      this.$router.push({ name: 'orderOpr', params: { id: row.id, type: 'edit', media: this.orderManage.mediaType } });
    },
    coypInfo(row) {
      this.$router.push({ name: 'orderOpr', params: { id: row.id, type: 'copy', media: this.orderManage.mediaType } });
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.managerOrder {
  .panel-content__table-wrap {
    margin-top: 15px;
  }
  .input_sm {
    .el-select {
      width: 134px;
    }
  }
  .el-tabs__item {
    text-align: center;
    width: 140px;
  }
  .selectBox {
    .wid210 {
      width: 210px;
    }
  }
  .tableBox {
    margin-top: 15px;
  }
}
</style>
